<template>
	<div style="width: 1650px;">
		<Tabs type="card">
			<TabPane label="账户管理">
				<AccountManage ref="AccountManage"></AccountManage>
			</TabPane>
			<TabPane label="落地页管理">
				<AdvPageManage ref="AdvPageManage"></AdvPageManage>
			</TabPane>
			<TabPane label="媒体代码管理">
				<SrcManage ref="SrcManage"></SrcManage>
			</TabPane>
		</Tabs>
	</div>

</template>

<script>
	import AccountManage from './AccountManage.vue';
	import AdvPageManage from './AdvPageManage.vue';
	import SrcManage from './SrcManage.vue';
	import {
		mapActions,
		mapGetters
	} from "vuex";
	export default {
		name: "loan_management",

		components: {
			AccountManage,
			AdvPageManage,
			SrcManage,
		},
	}
</script>

<style>
</style>
